import { FieldValues } from 'react-hook-form'
import { IFormField } from 'types'
import { FieldRenderer } from '../FieldRenderer'

type ReadonlyFieldProps<T extends FieldValues> = {
  field: IFormField<T>
  isLoading?: boolean
}

export const ReadonlyField = <T extends FieldValues>({
  field: rawField,
  isLoading
}: ReadonlyFieldProps<T>) => {
  const field = {
    ...rawField,
    isLoading
  } as IFormField<T>

  return <FieldRenderer field={field} readonly />
}
